export default "__VITE_ASSET__eac84425__"